import CardWithDiagram from './CardWithDiagram';

export default CardWithDiagram;
